export default __webpack_public_path__ + "f3f339af02a376af95021056a480d508.svg";